import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MapNotAvailableModalComponent } from 'src/app/modules/map/modals/map-not-available-modal/map-not-available-modal.component';

@Injectable({
  providedIn: 'root'
})
export class GeoLocationService {
  constructor(private dialog: MatDialog,) {}
  getCurrentPosition(): Promise<[number,number]> {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve([position.coords.latitude, position.coords.longitude]);
        },
        (error) => {
          this.dialog.open(MapNotAvailableModalComponent, {
            position: {
              top: '20%',
            },
            data: {
              title: 'Location Erorr',
              message: 'Please enable location services to use this feature.',
            },
          });
          reject(error);

        }
      );
    });
  }
}
